<!--
	回调事件  Click
-->
<template>
<label class="checkbox" :class="{disable:disabled}" :status="option.status" @click.prevent.stop="onClick">
	<div class="tableSys-noWidth vaT_E">
		<input type="checkbox" class="check-bg-main" v-model="check" :disabled="disabled">
		<div class="w105x">
			<div class="ico boxR-light tra-fast" :class="{bdSub:check==false,bdMain:check==true||option.status==2,disable:disabled}">
				<div class="checked bgMain tra-fast"></div>
				<i class="fa fa-check cWhite tra-fast"></i>
			</div>
		</div>
		<span class="content" v-html="text"></span>
	</div>
</label>
</template>
<script>
export default {
	name: 'Checkbox',
	props: {
		value: {
			type: Boolean,
			default: false
		},
		text: {
			type: String,
			default: ''
		},
		data: {// 监听的数据，用于判断选中状态
			type: [Object,Array]
		},
		keyMap:{
			type:String,
			default:"check"
		},
		// 传递的下标，多个循环时候使用
		index: {
			type: [Number, String]
		},
		status: {
			type: [Number, String],
			default: null
		},
		autoFix: {// 自动修正逻辑
			type: String,
			default: ''// emptyToAll:全不选自动全选,>1:必须选择1个以上
		},
		triggerClick: {// 设置自动更新数据后触发click回调
			type: Boolean,
			default: true
		},
		disabled: {
			type: Boolean,
			default: false
		},
		checkObj: {
			type: Object
		}
	},
	components: {},
	data () {
		return {
			option: {
				status: this.status
			},
			check: this.value
		}
	},
	watch: {
		check(val){
			// if(this.status==2) val=true;
			// else if(this.status==1||this.status==0) val=false;
			// this.$emit("input",val,this.index>=0? this.index:"all");
			// if(this.triggerClick) this.$emit("Click",val,this.index>=0? this.index:"all", this.checkObj);
			// this.$set(this,"check",val)//this.check=val;
			// trace(this.check)
			if(this.data) this.updateStatus();
		},
		status (val) {
			this.option.status = val
			if (val == 2) val = true
			else val = false
			this.check = val
			// this.$emit("Click","all");
		},
		value (val) {
			this.check = val;
		},
		data: {// 监听数据，更新状态
			deep: true,
			handler: function () { this.updateStatus();}
		}
	},
	methods: {
		updateStatus: function () { // 更新选中状态
			let $this = this, res = {yes: 0, max: 0}
			// if (this.keyMap) {
			// 	$.each(this.data, function () {
			// 		// this[$this.keyMap]
			// 	})
			// }
			// else {
				$.each(this.data,(index,val)=>{
					if (val===true||val[this.keyMap]) ++res.yes
					// else res+="0";
					++res.max
				});
				if (res.yes == 0) {
					this.option.status = '0';
					this.check = false
					if (this.data) {
						this.$nextTick(() => {
							this.$emit('Empty', this.check)
						})
					}
				} else if (res.yes == res.max) {
					this.option.status = '2';
					this.check = true
				} else if (res.yes > 0) {
					this.option.status = '1';
					this.check = false
				}
			// }
		},
		onClick ($event) {
			if ($($event.target).is('[href]')) { // 点击含有链接的元素进行跳转
				// window.open($(this.$el).find("[href]").attr("href"));
				let url = $($event.target).attr('href')
				let action = $($event.target).attr('target')
				if (action = '_blank') window.open(url)
				else this.$router.push(url)
			} else {
				// $event.stopPropagation()
				this.check = !this.check
				this.$emit('input', this.check, this.index >= 0 ? this.index:'all')
				this.$emit('Click', this.check, this.index >= 0 ? this.index:'all', this.checkObj)
				// if(this.data){
				// 	let $this=this;
				// 	if(this.keyMap){
				// 	}
				// 	else{
				// 		$.each(this.data,function(key){
				// 			// if($this.option.status)
				// 			// $this[key]=$this.check;
				// 			$this.$set($this.data,key,$this.check);
				// 		});
				// 		this.updateStatus();
				// 	}
				// }
				// this.$nextTick(()=>{
				// });
			}
		}
	},
	computed: {},
	mounted () {
		if (this.data) this.updateStatus()
	}
}
</script>
<style lang="scss" scoped>
.checkbox{display:inline-block;position:relative;cursor:pointer;
	[type="checkbox"]{display:none;position:absolute;}
	.ico{width:1.2em;height:1.2em;display:inline-block;position:relative;vertical-align:middle;
		.fa{margin:{left:-.52em;top:-.5em;};display:block;@extend .fa;position:absolute;top:50%;left:50%;transform:scale(0);transition-delay:.1s;}
	}
	:checked+*>.ico .fa{transform:scale(1);}

	.content{padding:{top:.15em;};}

	&[status]{
		.checked{position:absolute;top:0;left:0;}
	}
	&[status="0"] .checked{width:0;height:0;top:50%;left:50%;}
	&[status="1"] .checked{width:50%;height:50%;margin:{left:-25%;top:-25%;};top:50%;left:50%;border-radius:.2em;}
	&[status="2"]{
		.ico{//border-color:transparent;
			.fa{transform:scale(1);}
		}
		.checked{width:100%;height:100%;}
	}
	&.disable,.disable{
		opacity: .6;
		cursor: default;
	}

	//star
	&.checkbox-star{
		.ico{width:auto;height:auto;font-size:1.6em;line-height:.6em;opacity:.2;
			&:before{content:"★";}
			&:after{display:none;}
		}
		:checked+*>.ico{opacity:1;}
	}

	//onOff
	/*
	$onOffHeight:2em;
	&.checkbox-onOff{
		[type="checkbox"]+*{width:$onOffHeight * 2;height:$onOffHeight;border-radius:$onOffHeight;border:1px solid #e5e5e5;background-color:#fff;position:relative;transition-delay:.4s;
			&:before{content:"";@include size(100%);display:block;background-color:#fff;border-radius:$onOffHeight;@extend .tra;}
			&:after{content:"";@include size($onOffHeight - .2);display:block;background-color:#fff;border-radius:50%;position:absolute;top:0;left:0;box-shadow:0 .1em .5em rgba(#000,.4);@extend .tra;}
		}
		:checked+*{border:1px solid $green;background-color:$green;transition-delay:0s;
			&:before{transform:scale(0) translatex(50%);}
			&:after{left:$onOffHeight;}
		}
	}
	&.checkbox-onOff{
		[type="checkbox"]+*{width:$onOffHeight * 2;height:$onOffHeight;border-radius:$onOffHeight;background-color:rgba(#000,.2);position:relative;transition-delay:0;
			&:before{content:"";@include size($onOffHeight * 2 - .2,$onOffHeight - .2);display:block;background-color:#fff;border-radius:$onOffHeight;position:relative;top:.1em;left:.1em;@extend .tra;transition-delay:0;}
			&:after{content:"";@include size($onOffHeight - .2);display:block;background-color:#fff;border-radius:50%;position:absolute;top:.1em;left:.1em;box-shadow:0 .1em .5em rgba(#000,.4);@extend .tra;}
		}
		:checked+*{background-color:$green;transition-delay:0;
			&:before{width:0;margin:{left:80%;};transform:scale(0) translatex(50%);transition-delay:0;}
			&:after{left:$onOffHeight + .1;}
		}
	}
	*/
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/Checkbox.vue